import Analytics from '../../components/Analytics';

export default function initTracking() {
  const trackingElements = document.querySelectorAll('[data-gtag-category]');
  const ua = 'UA-107063633-1';

  if (trackingElements.length) {
    const gtagTracking = new Analytics(trackingElements, ua);
    gtagTracking.init();
  }
}
